module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/left-bottom-cdaaa13f7b41e7e083e95b14d5f42e5d.png";